import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HasPermissionDirective } from './has-permission.directive';
import { PermissionDisabledDirective } from './permission-disabled.directive';

@NgModule({
  declarations: [HasPermissionDirective, PermissionDisabledDirective],
  imports: [CommonModule],
  exports: [HasPermissionDirective, PermissionDisabledDirective],
})
export class AccessModule {}
